import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Sort from 'components/search/Sort';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import marketplace from 'cfg/marketplace.json';

import styles from 'styles/components/search/searchMenu.scss';
const {
  search: { sortOptions }
} = marketplace;

export class SearchMenu extends Component {
  static displayName = 'SearchMenu';

  makeFilterControl() {
    const { onToggleFacetsContainer, products: { trustedRetailers }, hydraCrossSiteSelling } = this.props;
    const { testId } = this.context;
    if (this.shouldRenderControl() || hydraCrossSiteSelling && trustedRetailers.length) {
      return (
        <button
          key="filters"
          type="button"
          className={styles.filters}
          data-test-id={testId('filterButton')}
          onClick={onToggleFacetsContainer}>
          {this.makeFilterText()}
        </button>
      );
    }
    return null;
  }

  makeFilterText() {
    const { isFacetsVisible } = this.props;
    return isFacetsVisible ? 'Close Filters' : `Filter${this.makeRenderedCount()}`;
  }

  makeMultSelectCount() {
    const { filters } = this.props;
    let multiCount = 0;
    Object.keys(filters.selected.multiSelects).filter(type => filters.selected.multiSelects[type]).forEach(filterType => {
      multiCount += filters.selected.multiSelects[filterType].length;
    });

    return multiCount;
  }

  makeRenderedCount() {
    const count = this.makeMultSelectCount();
    return count > 0 ? ` (${count})` : '';
  }

  makeSortControl(availableSortOptions = sortOptions) {
    const { filters, onSortSelected } = this.props;
    const { testId } = this.context;
    if (this.shouldRenderNonFilterControl()) {
      return (
        <span>
          <Sort
            tabIndex={0}
            sortOptions={availableSortOptions}
            onSortSelected={onSortSelected}
            selectedSort={filters.sort}
            filters={filters}
            testId={testId('selectSortValue')}
          />
        </span>
      );
    }
    return null;
  }

  shouldRenderControl() {
    const { filters: { selected, pageCount } } = this.props;
    return pageCount > 0 || (pageCount === 0 && Object.keys(selected.multiSelects).length > 0);
  }

  shouldRenderNonFilterControl() {
    const { isFacetsVisible } = this.props;
    return this.shouldRenderControl() && !isFacetsVisible;
  }

  render() {
    const { products: { totalProductCount }, hydraNewSearchNav } = this.props;
    const { testId } = this.context;
    return (
      <div className={styles.searchMenu}>
        <div className={styles.itemCount} data-test-id={testId('searchResultsItemCount')}>{totalProductCount} items</div>
        {!hydraNewSearchNav && this.makeSortControl()}
        {this.makeFilterControl()}
      </div>
    );
  }
}

SearchMenu.propTypes = {
  onSortSelected: PropTypes.func.isRequired,
  onToggleFacetsContainer: PropTypes.func.isRequired,
  filters: PropTypes.object,
  products: PropTypes.object,
  isFacetsVisible: PropTypes.bool
};

SearchMenu.contextTypes = {
  testId: PropTypes.func
};

export default withErrorBoundary('SearchMenu', SearchMenu);
